<template>
    <div class="position-relative" v-show="editingDescription">
        <textarea class="todo-description-textarea mt-2" @input="resizeTextArea" :placeholder="$t('todoDetails.notes')"
            ref="descriptionInput" @blur="doneEditDescription" v-model="desc">
                </textarea>
    </div>
    <div v-show="!editingDescription && desc != ''" class="mt-2 todo-description" @click="onDescriptionClick"
        v-html="todoDescription()"> </div>
    <div v-show="!editingDescription && desc.replace(/^\s*$(?:\r\n?|\n)/gm, '') == ''" @click="editDescription"
        class="description-empty mt-2">
        {{ $t("todoDetails.notes") }}
    </div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import markdownTargetBlankLinks from '../../helpers/markdownTargetBlankLinks';
import { resetMobileViewportZoom, ensureInputVisible, syncVisualViewportCss } from '../../helpers/mobileViewport';


export default {
    name: "descriptionTextArea",
    emits: ["updatedDescription"],
    data() {
        return {
            desc: "",
            editingDescription: false,
            md: new MarkdownIt()
        }
    },
    mounted() {
        markdownTargetBlankLinks.renderBlankLinks(this.md);
    },
    props: {
        todoDesc: { required: true }
    },
    methods: {
        resizeTextArea: function () {
            let textArea = this.$refs["descriptionInput"];
            textArea.style.height = "18px";
            textArea.style.height = textArea.scrollHeight + "px";
        },
        onDescriptionClick: function (event) {
            // 保留链接可点；其它区域单击进入编辑
            if (event.target && event.target.closest && event.target.closest("a")) return;
            this.editDescription();
        },
        editDescription: function () {
            this.editingDescription = true;
            this.$nextTick(function () {
                const input = this.$refs["descriptionInput"];
                if (!input) return;
                this.resizeTextArea();
                input.focus();
                input.setSelectionRange(0, 0);
                input.scrollTop = 0;
                syncVisualViewportCss();
                ensureInputVisible(input);
                window.setTimeout(() => {
                    syncVisualViewportCss();
                    ensureInputVisible(input);
                }, 320);
            });
        },
        doneEditDescription: function () {
            this.editingDescription = false;
            this.$emit('updatedDescription', this.desc);
            syncVisualViewportCss();
            resetMobileViewportZoom();
        },
        todoDescription: function () {
            return this.md.render(this.desc);
        },
    },
    watch: {
        todoDesc: {
            immediate: true,
            handler(newValue) {
                this.desc = newValue || "";
            },
        },
    },
}

</script>

<style>
.todo-description-textarea {
    font-size: 14px;
    line-height: 19px;
    min-height: 150px;
    overflow: hidden;
    width: 100%;
    resize: none;
    background: unset;
    cursor: auto;
    outline: unset;
    border: 2px solid black;
    border-radius: 3px;

    .dark-theme & {
        border: 1px solid rgba(255, 255, 255, 0.658);
        color: #c9d1d9;
    }
}

/* ≥16px 避免 iOS 聚焦输入框时整页放大且返回后不恢复 */
@media (max-width: 767px) {
    .todo-description-textarea {
        font-size: 16px;
        line-height: 22px;
    }
}

.todo-description {
    word-wrap: break-word;
    zoom: 89%;
    user-select: auto;
    -moz-user-select: auto;
    -webkit-user-drag: auto;
    -webkit-user-select: auto;
    -ms-user-select: auto;
    padding: 4px;
    border: 2px solid transparent;
    cursor: text;
}

.description-empty {
    color: grey;
    font-size: 14px;
    line-height: 21px;
    padding: 2px;
    border: 2px solid transparent;
    cursor: text;
}
</style>
